import axios from "axios";
import { baseUrl } from "./environment";

axios.defaults.baseURL = `${baseUrl}api/v1/`;
